import React from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Button } from "@mui/material";

function FileList({ files, onViewFile }) {
  if (!files || files.length === 0) {
    return <div>No files available.</div>;
  }

  const columns = [
    {
      field: "fileName",
      headerName: "File Name",
      flex: 1,
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 150,
      sortable: false,
      renderCell: (params) => (
        <Button
          variant="contained"
          size="small"
          onClick={() => {
            console.log("View button clicked for file:", params.row);
            if (onViewFile) onViewFile(params.row);
            console.log("boolean:" + onViewFile);
          }}
        >
          View
        </Button>
      ),
    },
  ];

  const rows = files.map((file, index) => ({
    id: file.id || index,
    fileName: file.fileName,
    ...file,
  }));
  console.log(rows);
  return (
    <div style={{ height: 300, width: "100%" }}>
      <DataGrid
        rows={rows}
        columns={columns}
        pageSize={6}
        rowsPerPageOptions={[10, 25, 50]}
        pagination
        disableSelectionOnClick
        autoHeight
      />
    </div>
  );
}

export default FileList;
